export const PRODUCT_SYSTEMS_CATALOG_CELL_ITEMS_TEST_ID = {
  image: 'product-catalog-image',
};
